import React from 'react';
import { bgColorClassname } from '@/utils';
import IframeResizer from '@iframe-resizer/react';

interface TicketTailorEmbedProps {
  backgroundColor?: {
    label: string;
    value: string;
  };
}

const TicketTailorEmbed: React.FC<TicketTailorEmbedProps> = ({ backgroundColor }) => {
  return (
    <div className={backgroundColor && bgColorClassname(backgroundColor)}>
      <div className='mx-auto flex max-w-screen-lg flex-col gap-6 px-5 py-8 md:p-[50px]'>
        <IframeResizer
          license={process.env.GATSBY_TICKET_TAILOR_LICENSE as string}
          src='https://www.tickettailor.com/events/nationalchildrensmuseum1/1342188/select-date?ref=website_widget&widget=true&minimal=true&show_logo=false&bg_fill=true'
          style={{ width: '100%', height: '100vh' }}
        />
      </div>
    </div>
  );
};

export default TicketTailorEmbed;
